export const testimonials = [
  {
    id: 1,
    name: "M.K様",
    age: "40代 / 会社員",
    rating: 5,
    text: "山田さんに担当いただき、フレンチネイルをお願いしました。細くて上品なラインが本当に素敵で、職場でも何度も褒めていただきました。施術中も丁寧にカウンセリングしてくださり、とても心地よい時間でした。",
    avatar: "MK"
  },
  {
    id: 2,
    name: "S.T様",
    age: "40代 / 主婦",
    rating: 5,
    text: "グラデーションネイルが得意な田中さんにお願いしました。肌馴染みが良く、家事をしても長持ちするのが嬉しいです。サロンの雰囲気もとても落ち着いていて、癒しの時間になっています。",
    avatar: "ST"
  },
  {
    id: 3,
    name: "Y.N様",
    age: "50代 / 自営業",
    rating: 5,
    text: "御堂筋線からすぐで、仕事帰りに通いやすいのが気に入っています。初めての訪問でも緊張せずに話せました。ワンカラーを定期的にお願いしていますが、いつもムラなく綺麗に仕上げていただけます。",
    avatar: "YN"
  },
  {
    id: 4,
    name: "A.O様",
    age: "40代 / 医療職",
    rating: 5,
    text: "清潔感があり、落ち着いた空間でゆったり過ごせます。スタッフの方々の対応がみなさん丁寧で、何でも相談できる雰囲気がいいです。施術のクオリティも大阪の中でも特に高いと感じています。",
    avatar: "AO"
  },
  {
    id: 5,
    name: "K.M様",
    age: "40代 / 教員",
    rating: 5,
    text: "鈴木さんのシンプルナチュラルなデザイン提案がとても好みに合っていました。目立ちすぎず、でもおしゃれな仕上がりで大満足です。電子マネーで支払えるのも便利で、また必ずリピートします。",
    avatar: "KM"
  },
  {
    id: 6,
    name: "R.H様",
    age: "30代 / IT企業",
    rating: 5,
    text: "BE:NAILさんは年齢を問わず通えるサロンだと思います。40代のお客様が多い分、落ち着いた空間でゆっくりできます。施術中もアドバイスをいただけるので、ネイルの知識も増えて楽しいです。",
    avatar: "RH"
  }
];
